import PrinterIcon from "@redotech/redo-icons/printer.svg";
import { ExistsFilterOperator } from "@redotech/redo-model/views/advanced-filters/exists-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ExistsTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const ScanVerifiedFilter: ExistsTableFilter = {
  type: AdvancedFilterType.EXISTS,
  data: {
    name: "scanVerified",
    type: AdvancedFilterType.EXISTS,
    value: null,
    operator: ExistsFilterOperator.EXISTS,
  },
  boolDisplay: { falseDisplay: "unverified", trueDisplay: "verified" },
  Icon: PrinterIcon,
  label: "Shipment",
  displayName: "Scan verified",
};
